import React from 'react';
import { changeTone, fmtChangePct, fmtPrice } from '../utils/formatters';

const TONE_CLASS = {
    up: 'text-[#2AA97A]',
    down: 'text-[#FF6B6B]',
    neutral: 'text-[#636369]',
};

const UpIcon = () => (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.59979 0.5C3.98469 -0.166667 4.94695 -0.166666 5.33185 0.5L8.79595 6.5C9.18085 7.16667 8.69972 8 7.92992 8H1.00172C0.231919 8 -0.249207 7.16667 0.135694 6.5L3.59979 0.5Z" fill="currentColor"/>
    </svg>
);

const DownIcon = () => (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.59882 7.5C3.98372 8.16667 4.94597 8.16667 5.33087 7.5L8.79497 1.5C9.17987 0.833334 8.69874 0 7.92894 0H1.00074C0.230942 0 -0.250183 0.833333 0.134717 1.5L3.59882 7.5Z" fill="currentColor"/>
    </svg>
);

export default function PriceTag({ price, changePct, compact = false }) {
    const tone = changeTone(changePct);
    const pctText = fmtChangePct(changePct);
    const priceText = fmtPrice(price);
    const size = compact ? 'text-[12px]' : 'text-[14px]';
    return (
        <div className={`flex items-center gap-[6px] font-bold whitespace-nowrap shrink-0 ${size}`}>
            <span className="text-[#111827]">{priceText}</span>
            {pctText && (
                <span className={`inline-flex items-center gap-[6px] whitespace-nowrap ${TONE_CLASS[tone]}`}>
                    {tone === 'up' && <UpIcon />}
                    {tone === 'down' && <DownIcon />}
                    {pctText}
                </span>
            )}
        </div>
    );
}
